import React from 'react';
import PropTypes from 'prop-types';
import { Title } from 'web-ui-components/lib/atoms/text';

import { default as content } from '../AddNewPayeeLandingPage/index.content';
import AddressForm from './AddressForm';
import { validationPropsProtoTypes, bankNameFieldPropTypes } from '../../states/addPayee/propTypes';
import { BankName, BankAddressLine1, BankCity, BankCountry } from './withValidationComponents';

const BankAddressDetails = ({
	validationProps,
	bankAddressLine1,
	bankAddressLine2,
	bankCity,
	bankPostalCode,
	bankCountry,
	bankName,
	showBankDetails,
}) => {
	const { bankNameLabel, bankDetailsTitle, postalCodeDescription } = content;
	if (!showBankDetails) {
		return null;
	}
	return (
		<span>
			<Title size="h1">{bankDetailsTitle}</Title>
			<BankName {...bankName} label={bankNameLabel} type="text" {...validationProps} />
			<AddressForm
				validationProps={validationProps}
				addressLine1={{
					id: 'bankAddressLine1',
					value: bankAddressLine1,
					bankAddressLine1,
					component: BankAddressLine1,
				}}
				addressLine2={{ id: 'bankAddressLine2', value: bankAddressLine2, bankAddressLine2 }}
				city={{ id: 'bankCity', value: bankCity, bankCity, component: BankCity }}
				postalCode={{ id: 'bankPostalCode', value: bankPostalCode, bankPostalCode, description: postalCodeDescription }}
				country={{ id: 'bankCountry', value: bankCountry, bankCountry, component: BankCountry }}
			/>
		</span>
	);
};

BankAddressDetails.propTypes = {
	validationProps: PropTypes.shape(validationPropsProtoTypes).isRequired,
	bankAddressLine1: PropTypes.string,
	bankAddressLine2: PropTypes.string,
	bankCity: PropTypes.string,
	bankPostalCode: PropTypes.string,
	bankCountry: PropTypes.string,
	bankName: PropTypes.shape(bankNameFieldPropTypes).isRequired,
	showBankDetails: PropTypes.bool.isRequired,
};

export default BankAddressDetails;
